import { ConnectivityState } from '../api/shared';

export const formatDuration = (latencyStr?: string): string => {
  if (!latencyStr) return '';

  let totalMs = 0;
  const hourMatch = latencyStr.match(/(\d+)h/);
  const minMatch = latencyStr.match(/(\d+)m(?!s)/);
  const secMatch = latencyStr.match(/(\d+(?:\.\d+)?)s/);
  const msMatch = latencyStr.match(/(\d+(?:\.\d+)?)ms/);

  if (hourMatch) totalMs += parseInt(hourMatch[1], 10) * 3600000;
  if (minMatch) totalMs += parseInt(minMatch[1], 10) * 60000;
  if (secMatch) totalMs += parseFloat(secMatch[1]) * 1000;
  if (msMatch) totalMs += parseFloat(msMatch[1]);

  if (totalMs === 0 && latencyStr) {
    const plainMs = latencyStr.match(/^(\d+)$/);
    if (plainMs) return `${plainMs[1]}ms`;
    return latencyStr;
  }

  if (totalMs < 1000) {
    return `${Math.round(totalMs)}ms`;
  } else if (totalMs < 60000) {
    return `${(totalMs / 1000).toFixed(2)}s`;
  } else {
    const minutes = Math.floor(totalMs / 60000);
    const seconds = ((totalMs % 60000) / 1000).toFixed(1);
    return `${minutes}m ${seconds}s`;
  }
};

export const getConnectivityStatusLabel = (state: ConnectivityState): string => {
  switch (state) {
    case ConnectivityState.CONNECTIVITY_STATE_CONNECTED:
      return 'Connected';
    case ConnectivityState.CONNECTIVITY_STATE_DISCONNECTED:
      return 'Disconnected';
    case ConnectivityState.CONNECTIVITY_STATE_UNTESTED:
      return 'Untested';
    default:
      return 'Unknown';
  }
};

export const getConnectivityStatusColor = (state: ConnectivityState): { bg: string; text: string; border: string } => {
  switch (state) {
    case ConnectivityState.CONNECTIVITY_STATE_CONNECTED:
      return { bg: 'bg-green-50', text: 'text-green-700', border: 'border-green-200' };
    case ConnectivityState.CONNECTIVITY_STATE_DISCONNECTED:
      return { bg: 'bg-red-50', text: 'text-red-700', border: 'border-red-200' };
    case ConnectivityState.CONNECTIVITY_STATE_UNTESTED:
      return { bg: 'bg-yellow-50', text: 'text-yellow-700', border: 'border-yellow-200' };
    default:
      return { bg: 'bg-gray-50', text: 'text-gray-700', border: 'border-gray-200' };
  }
};
